<template>
    <div class="page-container">
        <van-nav-bar title="商品兑换免责说明" fixed left-arrow @click-left="onClickLeft"></van-nav-bar>
   
        <div class="content">
            <div>1.	所有本活动提供的兑换礼品一经成功受理，即不可取消或退还积分。除礼品在运送途中发生损毁以外，恕不接受更换礼品。</div>
            <div>2.	积分兑换礼品及相关配送服务均由第三方供应商及服务机构提供，相关产品质量问题及配送服务问题天安金交中心概不承担任何责任，但可协助客户就相关问题与相关方进行协调处置。本业务项下的积分兑换业务不额外提供兑换礼品的发票。</div>
            <div>3.	客户一旦申请使用相关积分，即表明其认可全部积分业务规则及其相关修订内容，亦同意授权天安金交中心为采购或配送相关礼品及用于相关礼品质保等用途将客户或收货人相关个人信息包括但不限于姓名、邮寄地址及电话提供给第三方供应商或服务机构。</div>
            <div>4.	天安金交中心有权自主变更积分获取规则、积分可使用渠道和可兑换礼品范围，并可视客户风险情况随时冻结相关积分使用或取消已赠予的积分。</div>
        </div>
    </div>
</template>

<script>
    import { NavBar } from "vant";
    export default {
        name: "relief",
        components:{
            [NavBar.name]:NavBar
        },

        methods : {
			onClickLeft() {
				this.goableBack();
			}
            // goPrev(){
            //     this.goableBack();
            // }
        },
    }
</script>

<style lang="less" scoped>
    .page-container {
        line-height: 2;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 20px;
    }
    p {
        text-indent: 20px;
    }

	.content {
		margin-top: 20px;
	}
    .content > div {
        margin-bottom: 10px;
    }
    .content > div >b:first-child {
        margin-right: 14px;
    }
    .van-nav-bar {
        background: #fff;
        color:@dark;
        ::v-deep .van-nav-bar__title {
            color: @dark;
        }
        ::v-deep .van-icon {
            color: @dark !important;
        }
    }
</style>